// -------------------------------------
//   THIS MODULE WILL BE LOADED AT THE TOP OF ENTRY,
//   PLEASE KEEP IT AS CLEAN AS POSSIBLE.
// -------------------------------------

import { addLocale, useLocale } from 'ttag';

const DEFAULT_LOCALE = process.env.REACT_APP_DEFAULT_LOCALE || 'en';
const SUPPORTED_LOCALES = (process.env.REACT_APP_LOCALES || '').split(',');

/**
 * Loads locale file dynamically
 */
try {
  // Get locale with browser language preference
  const locale = getBrowserLocale();

  if (locale) {
    // load .po file with translations
    const translationsObj = require(`../l10n/${locale}.po`);

    addLocale(locale, translationsObj);
    useLocale(locale);
  }
} catch (err) {
  console.error('Failed to setup locale', err);
}

/**
 * Convert navigator language code to identified locale format
 */
function convertLanguageToLocale(language: string): string {
  // normalize the format because general browsers will return country code in uppercase, but not Safari... :(
  const lowercaseLanguage = language.toLowerCase();

  switch (lowercaseLanguage) {
    // Traditional Chinese
    case 'zh-tw':
    case 'zh-hk':
    case 'zh-hant':
      return 'zh_TW';
    // Simplified Chinese
    case 'zh':
    case 'zh-cn':
    case 'zh-sg':
      return 'zh_CN';
    // Japanese
    case 'ja':
    case 'ja-jp':
      return 'ja';
    // Korean
    case 'ko':
    case 'ko-kr': // South of Korea
    case 'ko-kp': // North of Korea
      return 'ko';
    // Fallback to English if others
    default:
      return 'en';
  }
}

/**
 * Get locale code depends on browser language preference
 */
function getBrowserLocale(): string {
  const locale = convertLanguageToLocale(navigator.language);

  // Fallback to default locale if browser locale is not supported
  return SUPPORTED_LOCALES.includes(locale) ? locale : DEFAULT_LOCALE;
}
